export default {
  LOGIN_USER: "LOGIN_USER",
  REGISTR_USER: "REGISTR_USER",
  USER_SIGNOUT: "USER_SIGNOUT",
  ADD_POINT: "ADD_POINT",
  USER_TASK_POINTS: "USER_TASK_POINTS",
};
